var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.importReport)?_c('PImportReport',{attrs:{"import-report":_vm.importReport,"error":_vm.error}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }